import markerUrl from '../../images/map-icons/marker.png';
import L from 'leaflet/dist/leaflet.js';

export default async function initLeafletMap() {

    const map = L.map('map', {
        center: [54.68029349793196, 25.291115460511485],
        zoom: 17,
        scrollWheelZoom: false,
    });

    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
        attribution: '',
        id: 'bokstospa/clocv16vh015401qv2sd02q87',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: 'pk.eyJ1IjoiYm9rc3Rvc3BhIiwiYSI6ImNsb2N2MDRnMDAxbnkyaW1lOTcwNmt4N20ifQ.T2h6Xh9cyrj87LgWCfr9-w'
    }).addTo(map);

    const LeafIcon = L.Icon.extend({
        options: {
            iconSize:     [166, 138],
            iconAnchor:   [84, 69]
        }
    });

    const icon = new LeafIcon({iconUrl: markerUrl});

    L.marker([54.68029349793196, 25.291115460511485], {icon: icon}).addTo(map);

}
